import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal } from "antd";
import MessageApi from '@api/message'
import SearchForm from '@components/SearchForm'
import { connect } from 'react-redux'
import Pover from '@/components/Pover'
import Title from '@/components/Title'
import Area from '@/components/threearea'
import Analysisapi from '@/api/analysis'
import moment from "moment"
import '@pages/message/sysmsg/style.scss'
const Pages = ({ history, dispatch, searchArgs }) => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]) // 表格数据
    const [station, setStation] = useState([])
    const [stationName, setStationName] = useState()
    // 搜索相关参数 
    const [searchParams, setSearchParams] = useState({
        pageNum: 1,
        pageSize: 10,
        station: stationName
    })

    // 搜索
    const [selectList, setSelectList] = useState([{
        name: "user",
        label: "人员",
        message: "请选择人员",
        options: [],
        span: 6,
        labelCol: 7
    }])

    // 搜索
    const [dateSearch] = useState([{
        name: "timeStart",
        label: "时间",
        message: "请选择站点",
        tag: "rangePicker",
        span: 8,
        labelCol: 4
    }])

    useEffect(() => {
        getListByPage()
        selectWithClassifyKey()
        return () => { }
    }, [searchParams])

    useEffect(() => {
		getStation()
    }, [])

    const getStationName = (stationName) => {
		setSearchParams({
			...searchParams,
			station: stationName
		})
		setStationName(stationName)
	}
    const getStation = (params) => {
		Analysisapi.getStation().then(res => {
			if (res.status == 0 && res.data) {
				setStation(res.data)
			}
		})
	}
    const getListByPage = () => {
        setLoading(true)
        MessageApi.listByPage({ ...searchParams }).then(res => {
            setLoading(false)
            if (res.status == 0 && res.data) {
                res.data.data.map((item, index) => {
                    item.index = (res.data.pageNum - 1) * res.data.pageSize + 1 + index
                })
                setData(res.data)
            }
        })
    }

     // 获取调整下拉框数据
     const selectWithClassifyKey = () => {
        MessageApi.userOptionList().then(res => {
            if (res.status == 0) {
                selectList[0].options = res.data.map(item => {
                    return {
                        value: item.realName,
                        title: item.realName
                    }
                })
                selectList[0].options.unshift({
                    title: "全部",
                    value: ''
                })
            }
        })
    }

    // 分页
    const handleTableChange = (pagination) => {
        let params = {
            ...searchParams,
            pageNum: pagination.current,
            pageSize: pagination.pageSize,
        }
        // dispatch(setStateSearchParams(params))
        setSearchParams(params)
    };

    /**
     * 搜索
     * @param params
     */
    const search = (params) => {
        let obj = {
            ...params,
            startDate: params.timeStart ? moment(params.timeStart[0]).format("YYYY-MM-DD") : null,
            endDate: params.timeStart ? moment(params.timeStart[1]).format("YYYY-MM-DD") : null,
            pageNum: 1,
            pageSize: 10,
            station: stationName
        }
        // dispatch(setStateSearchParams(obj))
        setSearchParams(obj)
    }

    /**
     * 重置
     */
    const reset = () => {
        let obj = {
            pageNum: 1,
            pageSize: 10,
            userCode: null,
            billingCode: null
        }
        // dispatch(setStateSearchParams(obj))
        setSearchParams(obj)
    }

   
    /**
     *
     * @param obj
     * 更新数据
     */


    /**
     * table配置
     * @type {*[]}
     */
    const columns = [
        {
            title: '厂站',
            dataIndex: 'station',
            align: 'center',
            width: 200,
            key: 'index',
            fixed: "left",
        },
        {
            title: '人员',
            dataIndex: 'user',
            key: 'typeId',
            align: 'center',
			width: 200
        },
        {
            title: '描述',
            dataIndex: 'description',
            align: 'center',
            key: 'title',
            render: text => Pover(text, 14)
        },
        {
            title: '时间',
            dataIndex: 'createAt',
            align: 'center',
            key: "sendTime",
			 width: 200,
        },
        // {
        //     title: '状态',
        //     dataIndex: 'status',
        //     align: 'center',
        //     key: 'status',
        //     render: text => text == 1 ? "未读" : "已读"
        // }
    ]

    return (
        
        <div className='base  basecontent' style={{position:'relative'}}>
            <Title title="系统日志"></Title>		
			<div className='Area'>
                 <span style={{ position: 'absolute', marginLeft: '-51px', borderBottom: '1px solid #EEF0F3', padding: '11px 15px 12px 5px', zIndex: '999' }}>厂站:</span>  
                 <Area station={station} getStationName={getStationName} />
			</div>
			<div className='ptable'>
            <SearchForm span={6} selectList={selectList} setSelectList={setSelectList} dateSearch={dateSearch}  onSearch={search} />
				<div>
					<Table
						columns={columns}
						dataSource={data.data}
						rowKey={record => record.id}
						pagination={{
							current: data.pageNum,
							pageSize: data.pageSize,
							showQuickJumper: true,
							showSizeChanger: true,
							showTotal: total => `共${total}条数据`,
							total: data.total
						}}
						onChange={handleTableChange}
						loading={loading}
					/>

				
				</div>
			</div>
        </div >
    )
}
const mapStateToProps = state => {
    return {
        ...state.Common
    }
};

export default connect(mapStateToProps)(Pages)